// admin-billing.js - Stripe transactions view (admin).
// Reads /api/stripe/admin/transactions (live Stripe API).

function token() { return localStorage.getItem('gdbs_token') || ''; }

async function api(method, path) {
  const headers = { 'Content-Type': 'application/json' };
  if (token()) headers['Authorization'] = 'Bearer ' + token();
  const res = await fetch(path, { method, headers });
  if (!res.ok) throw new Error(`${method} ${path}: ${res.status}`);
  return res.json();
}

function escapeHtml(s) {
  if (s === null || s === undefined) return '';
  return String(s).replace(/[&<>"']/g, c => ({ '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;','\'':'&#39;' }[c]));
}

function formatAmount(cents, currency) {
  if (typeof cents !== 'number') return '-';
  const v = (cents / 100).toFixed(2);
  return `${v} ${(currency || 'usd').toUpperCase()}`;
}

function statusPill(row) {
  // succeeded / pending / failed plus refunded / disputed flags.
  const s = (row.status || row.Status || '').toLowerCase();
  const refunded = row.refunded ?? row.Refunded;
  const disputed = row.disputed ?? row.Disputed;
  const paid = row.paid ?? row.Paid;
  let color = 'var(--text-dim)';
  let label = s;
  if (disputed) { color = '#dc2626'; label = 'disputed'; }
  else if (refunded) { color = '#f59e0b'; label = 'refunded'; }
  else if (s === 'succeeded' && paid) { color = '#10b981'; label = 'paid'; }
  else if (s === 'failed') { color = '#dc2626'; label = 'failed'; }
  else if (s === 'pending') { color = '#3b82f6'; label = 'pending'; }
  return `<span style="display:inline-block;padding:2px 8px;border-radius:9999px;font-size:10.5px;font-weight:600;background:color-mix(in oklch, ${color} 18%, transparent);color:${color};text-transform:uppercase;letter-spacing:0.04em;">${escapeHtml(label)}</span>`;
}

async function refresh() {
  const status = document.getElementById('admin-bil-status');
  const body = document.getElementById('admin-bil-body');
  const limit = parseInt(document.getElementById('admin-bil-limit').value) || 100;
  status.innerHTML = '<i class="fas fa-spinner fa-spin"></i> querying Stripe...';
  body.innerHTML = '<tr><td colspan="7" class="admin-empty">Loading from Stripe...</td></tr>';
  try {
    const res = await api('GET', '/api/stripe/admin/transactions?limit=' + limit);
    const rows = (res.data && res.data.rows) || [];
    status.innerHTML = `<i class="fas fa-check-circle" style="color:#10b981;"></i> ` +
      `${rows.length} charges (live from Stripe API)`;
    if (rows.length === 0) {
      body.innerHTML = '<tr><td colspan="7" class="admin-empty">No transactions yet.</td></tr>';
      return;
    }
    body.innerHTML = rows.map(r => {
      const created = r.createdUtc || r.CreatedUtc || '';
      const email = r.customerEmail || r.CustomerEmail || '';
      const amount = formatAmount(r.amountCents ?? r.AmountCents, r.currency || r.Currency);
      const desc = r.description || r.Description || r.failureMessage || r.FailureMessage || '';
      const receipt = r.receiptUrl || r.ReceiptUrl;
      const id = r.chargeId || r.ChargeId || '';
      const dashUrl = `https://dashboard.stripe.com/payments/${escapeHtml(id)}`;
      return `<tr>
        <td><code>${escapeHtml(created.slice(0, 19))}</code></td>
        <td>${escapeHtml(email)}</td>
        <td style="text-align:right;font-variant-numeric:tabular-nums;">${escapeHtml(amount)}</td>
        <td>${statusPill(r)}</td>
        <td style="max-width:280px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;" title="${escapeHtml(desc)}">${escapeHtml(desc)}</td>
        <td>${receipt ? `<a href="${escapeHtml(receipt)}" target="_blank" rel="noopener" style="color:var(--accent);">view</a>` : '-'}</td>
        <td><a href="${dashUrl}" target="_blank" rel="noopener" style="color:var(--accent);font-family:monospace;font-size:11px;" title="${escapeHtml(id)}">${escapeHtml(id.slice(0, 14))}...</a></td>
      </tr>`;
    }).join('');
  } catch (e) {
    status.innerHTML = `<i class="fas fa-times-circle" style="color:var(--accent-red,oklch(60% 0.20 25));"></i> ${escapeHtml(e.message)}`;
    body.innerHTML = `<tr><td colspan="7" class="admin-empty">${escapeHtml(e.message)}</td></tr>`;
  }
}

export function initAdminBilling() {
  const btn = document.getElementById('btn-bil-refresh');
  if (btn) btn.addEventListener('click', refresh);
}
